import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0203a994"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header_title logo" }, null, -1));
const _hoisted_3 = { class: "header_title pair" };
const _hoisted_4 = { class: "header_title price" };
const _hoisted_5 = { class: "header_title change" };
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, CURRENCY_PAIR_HEADERS } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(format)(_unref(CURRENCY_PAIR_HEADERS).PAIR)), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(_unref(CURRENCY_PAIR_HEADERS).PRICE)), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(CURRENCY_PAIR_HEADERS).CHANGE)), 1)
            ]));
        };
    }
});
